import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';

export interface SaveCategoryDTO {
  id: string;
  orderNumber: number;
  fulfillmentValue: number;
}

interface FetcherParams {
  clientId: string;
  categories: SaveCategoryDTO[];
}

const saveWorkflow = ({ clientId, categories }: FetcherParams) => {
  return authFetch('/Consumer/PulseCheckResultUpdate', {
    method: 'POST',
    ...httpBodyOptions({ clientId, fulfillmentCategories: categories }, true),
  });
};

export const useSaveWorkflowMutation = () => {
  return useMutation(saveWorkflow);
};
